import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddTourProgramApproval } from "../../../domain/useages/tour-program-approval/add-tour-program-approval";
import { RemoteAddTourProgramApproval } from "../../../data/usecases/tour-program-approval/remote-add-tour-program-approval";

export interface AddTourProgramApprovalInterface {
  AddTourProgramApprovalState: FetchState;
  addTourProgramApproval: Function;
}

const initialStates = {
  AddTourProgramApprovalState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddTourProgramApprovalSlice: StateCreator<
  AddTourProgramApprovalInterface
> = (set) => ({
  ...initialStates,
    addTourProgramApproval: async (payload: AddTourProgramApproval.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddTourProgramApproval = new RemoteAddTourProgramApproval(
      `${BASE_URL}${Endpoints.ADD_TOUR_PROGRAM_APPROVAL}`,

      axiosHttpClient
    );

    set(() => ({ AddTourProgramApprovalState: FetchState.LOADING }));
    let result = await remoteAddTourProgramApproval.update(payload);
    return result;
  },
});
